import { render, staticRenderFns } from "./BaseAddressForm.vue?vue&type=template&id=fc90f1c0&"
import script from "./BaseAddressForm.js?vue&type=script&lang=js&"
export * from "./BaseAddressForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BaseAddressForm.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcheckout%2FBaseAddressForm%2FBaseAddressForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports